export const getSpecialClientType = (_selectedPerson) => {
		 if (_selectedPerson.membershipCode == process.env.NEXT_PUBLIC_HOTEL_MEMBERSHIPCODE) {
			return 'hotel';
		 }
		 if (_selectedPerson.membershipCode == process.env.NEXT_PUBLIC_EVENTS_MEMBERSHIPCODE) {
			return 'events';
		 }
		 if (_selectedPerson.membershipCode == process.env.NEXT_PUBLIC_GRAT_MEMBERSHIPCODE) {
			return 'grat';
		 }
		 if (_selectedPerson.membershipCode == process.env.NEXT_PUBLIC_CASINO_MEMBERSHIPCODE) {
			return 'casino';
		 }
		 if (_selectedPerson.membershipCode == process.env.NEXT_PUBLIC_CASINO_OWNER_MEMBERSHIPCODE) {
			return 'casinoowner';
		 }
     return 'client'
  }